<template>
  <section class="featured bg-gradient pd-bottom">
    <h2 class="visually-hidden">{{ $t("home.promos.title") }}</h2>
    <div class="slider-wp"
      v-show="loading"
    >
      <tiny-slider class="slider1-edge no-bullet"
        :edge-padding="40"
        :gutter="25"
        :controls="false"
        nav-position="bottom"
        :swipe-angle="45"
        :auto-height="true"
        :responsive="{ 560: 2, 768: 3, 1024: 4, 1200: 5, 1500: 6 }"
        :loop="false"
        prevent-scroll-on-touch="auto"
        key="placeholder-carousel"
        id="placeholder-carousel"
      >
        <li v-for="i in 6">
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage" >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img :src="constants.phImg600x600" alt="">
            </a>
            <div class="txt center-align">
              <h3 class=""><a href="" class="ph-text"
                @click.prevent=""
              >■■■■■■■■■■■■■■■■■■</a></h3>
              <div class="quiet small" v-if="(i % 2) === 1">
                <time datetime="" class="ph-text">■■■■■■■</time>
                <span class="duration ph-text">■■■■■■■</span>
              </div>
            </div>
          </div>
        </li>
      </tiny-slider>
    </div>
    <div class="slider-wp"
      v-if="!loading && promotions"
    >
      <tiny-slider class="slider1-edge no-bullet"
        :edge-padding="40"
        :gutter="25"
        :controls="false"
        nav-position="bottom"
        :swipe-angle="45"
        :auto-height="true"
        :responsive="{ 560: 2, 768: 3, 1024: 4, 1200: 5, 1500: 6 }"
        :loop="false"
        prevent-scroll-on-touch="auto"
        key="loaded-carousel"
        id="loaded-carousel"
      >
        <li
          v-for="promotion in promotions"
          :key="promotion.id"
        >
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage"
            @click.prevent="navigatorPush('Host', { id: promotion.host.id, title: promotion.host.user.name })"
            v-if="promotion.type === 'host'"
          >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img-with-placeholder :src="constants.phImg600x600" :data-src="sizeImg(promotion.image.mapped_base_url, 600, 600)" :alt="promotion.image.alt_text" />
            </a>
            <div class="lab"
              v-if="['hot', 'new', 'sponsored'].includes(promotion.label)"
              v-bind:class="[promotion.label]"
            >{{ $t(`home.promos.labels.${promotion.label}`) }}</div>
            <div class="txt center-align">
              <h3 class=""><a href=""
                @click.prevent=""
              >{{ promotion.text }}</a></h3>
            </div>
          </div>
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage"
            @click.prevent="navigatorPush('Channel', { id: promotion.channel.id, title: promotion.channel.title })"
            v-else-if="promotion.type === 'channel'"
          >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img-with-placeholder :src="constants.phImg600x600" :data-src="sizeImg(promotion.image.mapped_base_url, 600, 600)" :alt="promotion.image.alt_text" />
            </a>
            <div class="lab"
              v-if="['hot', 'new', 'sponsored'].includes(promotion.label)"
              v-bind:class="[promotion.label]"
            >{{ $t(`home.promos.labels.${promotion.label}`) }}</div>
            <div class="txt center-align">
              <h3 class=""><a href=""
                @click.prevent=""
              >{{ promotion.text }}</a></h3>
            </div>
          </div>
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage"
            @click.prevent="navigatorPush('Episode', { id: promotion.episode.id, title: promotion.episode.title })"
            v-else-if="promotion.type === 'episode'"
          >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img-with-placeholder :src="constants.phImg600x600" :data-src="sizeImg(promotion.image.mapped_base_url, 600, 600)" :alt="promotion.image.alt_text" />
              <span class="play icon icon-md">
                <icon-play />
              </span>
            </a>
            <div class="lab"
              v-if="['hot', 'new', 'sponsored'].includes(promotion.label)"
              v-bind:class="[promotion.label]"
            >{{ $t(`home.promos.labels.${promotion.label}`) }}</div>
            <div class="txt center-align">
              <h3 class=""><a href=""
                @click.prevent=""
              >{{ promotion.text }}</a></h3>
              <!-- <div class="quiet small">
                <time :datetime="timestampToDate(promotion.episode.published_at)">{{ promotion.episode.published_at | timestampHumanizeFromNow | titleize }}, </time>
                <span class="duration">{{ promotion.episode.duration | secondsToDuration }}</span>
              </div> -->
            </div>
          </div>
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage"
            @click.prevent="navigatorPush('Tag', { id: promotion.tag.id, title: promotion.tag.name })"
            v-else-if="promotion.type === 'tag'"
          >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img-with-placeholder :src="constants.phImg600x600" :data-src="sizeImg(promotion.image.mapped_base_url, 600, 600)" :alt="promotion.image.alt_text" />
            </a>
            <div class="lab"
              v-if="['hot', 'new', 'sponsored'].includes(promotion.label)"
              v-bind:class="[promotion.label]"
            >{{ $t(`home.promos.labels.${promotion.label}`) }}</div>
            <div class="txt center-align">
              <h3 class=""><a href=""
                @click.prevent=""
              >{{ promotion.text }}</a></h3>
            </div>
          </div>
          <div class="is-card is-card__primary js-imgcolor-bg js-loading js-newpage"
            @click.prevent="navigatorOpenExternal(promotion.url)"
            v-else-if="promotion.type === 'external'"
          >
            <a class="has-icon icon-lb" href=""
              @click.prevent=""
            >
              <img-with-placeholder :src="constants.phImg600x600" :data-src="sizeImg(promotion.image.mapped_base_url, 600, 600)" :alt="promotion.image.alt_text" />
            </a>
            <div class="lab"
              v-if="['hot', 'new', 'sponsored'].includes(promotion.label)"
              v-bind:class="[promotion.label]"
            >{{ $t(`home.promos.labels.${promotion.label}`) }}</div>
            <div class="txt center-align">
              <h3 class=""><a href=""
                @click.prevent=""
              >{{ promotion.text }}</a></h3>
            </div>
          </div>
        </li>
      </tiny-slider>
    </div>
  </section>
</template>

<script>
import VueTinySlider from '@/vendors/vue-tiny-slider';

export default {
  props: ['loading', 'promotions'],
  components: {
    'tiny-slider': VueTinySlider,
  },
};
</script>
